// THE FILE CONTAINE CUSTOM TEXTINPUT WITH LEFTSIDE SPACE FOR THE ICON
import { TextField, InputAdornment } from '@mui/material';

function CustomTextFieldWithIcon({
    id,
    name,
    defaultValue,
    onMouseDown,
    placeholder,
    type,
    onChange,
    onBlur,
    value,
    error,
    helperText,
    inputProps,
    isDisabled,
    autoFocus,
    StartIcon,
    EndIcon,
    onEndIconClick,
    width = '100%',
    maxLength = 255, //added max length for number,

}) {
    const ModifiedTextField = {
        '& .MuiOutlinedInput-root': {
            fontFamily: 'Inter',
            fontSize: '15px',

            paddingLeft: '6px',
            '& fieldset': {
                borderColor: '#C0C0C0',
            },
            '&:hover fieldset': {
                borderColor: '#C0C0C0',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#C0C0C0',
            },
        },
        '& .MuiInputBase-input': {
            // paddingLeft: '15px',
            // display: 'flex',
        },
        '& .MuiInputBase-input.Mui-disabled': {
            WebkitTextFillColor: '#272727',

        },
    };
    const sideMenuStyles = {
        // position: 'relative',
        // zIndex: 2, // Ensure side menu is on top
        // overflow: 'hidden', // Prevent overflow outside of the menu
        background: isDisabled ? 'hsl(0, 0%, 95%)' : '',
    };

    return (
        <div style={{ width }}  >
            <TextField
                style={sideMenuStyles}
                autoFocus={false}
                id={id}
                disabled={isDisabled}
                className="modified_text_field"
                name={name}
                fullWidth
                // autoComplete="off"
                size="small"

                placeholder={placeholder}
                onChange={onChange}
                // onBlur={onBlur}
                value={value ?? ''}
                //   defaultValue={defaultValue}
                error={error}
                type={type}
                helperText={helperText}
                variant="outlined"
                sx={ModifiedTextField}
                onMouseDown={onMouseDown}
                inputProps={{
                    ...(inputProps || {}),
                    ...(type === 'number' ? { min: 0, inputMode: 'numeric' } : {}),
                    maxLength: maxLength || undefined,
                    autoComplete: 'new-password', // FOR REMOVE AUTO FILL OPTION 
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            {/* {StartIcon ? <StartIcon className='start-icon' /> : null}  */}
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            {EndIcon ? <EndIcon onClick={onEndIconClick} className='end-icon' /> : null}
                        </InputAdornment>
                    ),
                }}
            />
        </div>
    );
}

export default CustomTextFieldWithIcon;

// import { TextField, InputAdornment } from '@mui/material';
// import React, { useRef } from 'react';

// function CustomTextFieldWithIcon({
//     id,
//     name,
//     defaultValue,
//     onMouseDown,
//     placeholder,
//     type,
//     onChange,
//     onBlur,
//     value,
//     error,
//     helperText,
//     inputProps,
//     isDisabled,
//     autoFocus,
//     StartIcon,
//     EndIcon,
//     onEndIconClick,
//     width = '100%',
//     maxLength = 255,
//     keyCooldown = 50, // cooldown in milliseconds (for handleing key board pressing same charatcers )
// }) {
//     const cooldownRef = useRef(0);

//     // Allow list of non-character keys (no delay for these)
//     const allowedKeys = new Set([
//         'Shift', 'Control', 'Alt', 'Meta', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
//         'Tab', 'CapsLock', 'Escape', 'Delete', 'Enter'
//     ]);

//     const handleKeyDown = (e) => {
//         if (allowedKeys.has(e.key)) return;

//         const now = Date.now();
//         if (now - cooldownRef.current < keyCooldown) {
//             e.preventDefault(); // Block rapid typing
//             return;
//         }
//         cooldownRef.current = now;
//     };
//     const ModifiedTextField = {
//         '& .MuiOutlinedInput-root': {
//             fontFamily: 'Inter',
//             fontSize: '15px',
//             paddingLeft: '6px',
//             '& fieldset': {
//                 borderColor: '#C0C0C0',
//             },
//             '&:hover fieldset': {
//                 borderColor: '#C0C0C0',
//             },
//             '&.Mui-focused fieldset': {
//                 borderColor: '#C0C0C0',
//             },
//         },
//         '& .MuiInputBase-input.Mui-disabled': {
//             WebkitTextFillColor: '#272727',
//         },
//     };

//     const sideMenuStyles = {
//         background: isDisabled ? 'hsl(0, 0%, 95%)' : '',
//     };

//     return (
//         <div className={` ${width ? 'force-full-width-mobile' : ''}`} style={{ width: width || '100%' }}>
//             <TextField
//                 style={sideMenuStyles}
//                 autoFocus={false}
//                 id={id}
//                 disabled={isDisabled}
//                 className="modified_text_field"
//                 name={name}
//                 fullWidth
//                 autoComplete="off"
//                 size="small"
//                 placeholder={placeholder}
//                 onChange={onChange}
//                 // onBlur={onBlur}
//                 // value={value}
//                 value={value ?? ''}
//                 error={error}
//                 type={type}
//                 helperText={helperText}
//                 variant="outlined"
//                 sx={ModifiedTextField}
//                 onMouseDown={onMouseDown}
//                 onKeyDown={handleKeyDown}
//                 inputProps={{
//                     ...(inputProps || {}),
//                     ...(type === 'number' ? { min: 0, inputMode: 'numeric' } : {}),
//                     maxLength: maxLength || undefined,
//                 }}
//                 InputProps={{
//                     startAdornment: (
//                         <InputAdornment position="start">
//                         </InputAdornment>
//                     ),
//                     endAdornment: (
//                         <InputAdornment position="end">
//                             {EndIcon ? <EndIcon onClick={onEndIconClick} className="end-icon" /> : null}
//                         </InputAdornment>
//                     ),
//                 }}
//             />
//         </div>
//     );
// }

// export default CustomTextFieldWithIcon;

